import { useSelector } from 'react-redux';

import { getPricingStructure } from 'ha/modules/Pricing';
import { getAdvertiser } from '../selectors';

export function useLocalPricing() {
  const advertiser = useSelector(getAdvertiser);

  const pricingStructure = getPricingStructure({
    advertiser,
  });

  return {
    pricingStructure,
  };
}
